import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 100 100",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M82.37 50.191a4.167 4.167 0 0 1 5.89.036l7.357 7.447a4.167 4.167 0 0 1-.036 5.892l-24.04 23.746a2.9 2.9 0 0 1-1.696.819l-9.018 1.11c-2.727.335-5.025-2.017-4.63-4.736l1.233-8.496a4.17 4.17 0 0 1 1.196-2.364zm-.078-29.358a3.125 3.125 0 0 1 3.125 3.125v16.667a3.125 3.125 0 0 1-6.25 0v-9.562L46.903 60.637a3.13 3.13 0 0 1-2.111.826 3.13 3.13 0 0 1-2.112-.826L10.417 31.063v46.02h31.25a3.126 3.126 0 0 1 0 6.25h-31.25a6.25 6.25 0 0 1-6.25-6.25V23.958a3.125 3.125 0 0 1 3.125-3.125zM63.127 77.405l-.843 5.781 5.867-.72 16.391-16.198-5.009-5.07zm20.557-20.308 5.012 5.078 1.604-1.587-5.018-5.074zm-38.892-3.003 29.463-27.011H15.328z" }, null, -1)
  ]))]))
}
export default { render: render }